import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
Vue.use(firestorePlugin)

// firebase init goes here
const config = {
  apiKey: "AIzaSyC4G9VrKixgBEeRo4CsBqtHprNj7q4fuCM",
  authDomain: "williamorosky-personal-website.firebaseapp.com",
  databaseURL: "https://williamorosky-personal-website.firebaseio.com",
  projectId: "williamorosky-personal-website",
  storageBucket: "williamorosky-personal-website.appspot.com",
  messagingSenderId: "188018639703",
  appId: "1:188018639703:web:2cfa430674d2e2fb01b412",
  measurementId: "G-B0Z0SR65JY"
}

firebase.initializeApp(config)
// export const db = firebase.firestore()
// export const imagesRef = db.ref('images')

Vue.config.productionTip = false

new Vue({
  router,
  components: { App },
  render: h => h(App)
}).$mount('#app')
